import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import { sequenceDebugActions } from ".";
import {
  FETCH_SEQUENCE_DEBUG_PROGRESS,
  FETCH_SEQUENCE_DEBUG_SUCCESS,
  FETCH_SEQUENCE_DEBUG_FAILED,
  FETCH_PENDING_JOBS_PROGRESS,
  FETCH_PENDING_JOBS_SUCCESS,
  FETCH_PENDING_JOBS_FAILED,
  CLEAR_SEQUENCE_DEBUG_STATE,
} from "./SequenceDebugActions";
import { initialSequenceDebugState } from "./defaultState";
import { ISequenceDebugState } from "./SequenceDebug.types";

export const sequenceDebugReducer = (
  state: IStoreState["sequenceDebug"] = initialSequenceDebugState,
  action: sequenceDebugActions,
) => {
  switch (action.type) {
    case FETCH_SEQUENCE_DEBUG_PROGRESS:
      return produce(state, (draft: ISequenceDebugState) => {
        draft.loading = LoadState.InProgress;
      });

    case FETCH_SEQUENCE_DEBUG_SUCCESS:
      return produce(state, (draft: ISequenceDebugState) => {
        draft.loading = LoadState.Loaded;
        draft.state = action.payload.state;
        draft.activeSequence = action.payload.activeSequence;
      });

    case FETCH_SEQUENCE_DEBUG_FAILED:
      return produce(state, (draft: ISequenceDebugState) => {
        draft.loading = LoadState.Failed;
      });

    case FETCH_PENDING_JOBS_PROGRESS:
      return produce(state, (draft: ISequenceDebugState) => {
        draft.loading = LoadState.InProgress;
      });

    case FETCH_PENDING_JOBS_SUCCESS:
      return produce(state, (draft: ISequenceDebugState) => {
        draft.loading = LoadState.Loaded;
        draft.pendingJobs = action.payload.data;
      });

    case FETCH_PENDING_JOBS_FAILED:
      return produce(state, (draft: ISequenceDebugState) => {
        draft.loading = LoadState.Failed;
      });

    case CLEAR_SEQUENCE_DEBUG_STATE:
      return initialSequenceDebugState;

    default:
      return state;
  }
};
